import { ExpensableBudgetFragment } from 'generated/resources/graphql'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import i18n from 'modules/core/lib/i18n'

import { BudgetOption } from 'modules/finance/hooks/useBudgets'

interface Props {
  selectedBudgetId?: number | string
  expensableBudget?: ExpensableBudgetFragment | null
  budgetOptions: BudgetOption[]
  error?: string
  mandatory?: boolean
  readonly?: boolean
  loading?: boolean
  onSelect: (budgetId: number | null) => void
}

const BudgetField = ({
  selectedBudgetId,
  expensableBudget,
  budgetOptions,
  error,
  mandatory = false,
  readonly,
  loading,
  onSelect,
}: Props) => {
  const parsedSelectedBudgetId =
    typeof selectedBudgetId === 'string' ? Number.parseInt(selectedBudgetId, 10) : selectedBudgetId
  const selectedBudgetOption = budgetOptions.find(
    ({ value: budgetId }) => parsedSelectedBudgetId === budgetId
  )

  return (
    <DropdownSearchBar
      name={selectedBudgetOption?.label || expensableBudget?.name || ''}
      label={i18n.t('budgets.forms.external_resource.budget_field.label')}
      ariaLabel={'budget-popover'}
      data={budgetOptions}
      error={error}
      selectLabel={i18n.t('budgets.forms.external_resource.budget_field.options.empty')}
      placeholder={i18n.t('budgets.forms.external_resource.budget_field.options.empty')}
      searchLabel={i18n.t('common.search')}
      sortLabel={i18n.t('common.name')}
      labelNotFound={i18n.t('budgets.forms.external_resource.budget_field.search.not_found')}
      disabled={readonly}
      loading={loading}
      autofocus={false}
      mandatory={mandatory}
      onSelectEmpty={!mandatory ? () => onSelect(null) : null}
      onSelect={(item) => {
        onSelect(
          typeof item.value === 'string' ? Number.parseInt(item.value, 10) || null : item.value
        )
      }}
    />
  )
}

export default BudgetField
